import _regeneratorRuntime from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var _this = this;

import * as tslib_1 from "tslib";
import { GetPnLUrl } from '../constants';
import _ from 'lodash';
import dayjs from 'dayjs';

var get = function get(api) {
  return function (request) {
    return tslib_1.__awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var apiResponse, sanitizedPnLItems;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return api.get(GetPnLUrl, request);

            case 2:
              apiResponse = _context.sent;
              sanitizedPnLItems = _.map(apiResponse.payload.Items, function (item) {
                var closeAmount = Number(item.CloseAmount);
                var closeOrderId = Number(item.CloseOrderId);
                var costBasis = Number(item.CostBasis);
                var dateClosed = dayjs(item.DateClosed).toDate();
                var dateOpened = dayjs(item.DateOpened).toDate();
                var openOrderId = Number(item.OpenOrderId);
                var quantity = Number(item.Quantity);
                return Object.assign({}, item, {
                  CloseAmount: closeAmount,
                  CloseOrderId: closeOrderId,
                  CostBasis: costBasis,
                  DateClosed: dateClosed,
                  DateOpened: dateOpened,
                  OpenOrderId: openOrderId,
                  Quantity: quantity
                });
              });
              return _context.abrupt("return", Object.assign({}, apiResponse, {
                payload: apiResponse.payload ? Object.assign({}, apiResponse.payload, {
                  Items: sanitizedPnLItems
                }) : undefined
              }));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };
};

export var pnlHistory = {
  get: get
};